import { CaseType } from '@brands/services/cases/types/ICase';
import { Pricings } from '@brands/services/identity/getPricings';

export const priceFor = (list: Pricings[] | null | undefined, caseType: CaseType): Pricings | undefined =>
  list?.find((p) => Array.isArray(p.case_types) && p.case_types.includes(caseType));

// Client/division-scoped pricing rows carry their own display label; fall
// back to the brand's default card title when no listed case type has one.
export const priceLabelFor = (
  list: Pricings[] | null | undefined,
  caseTypes: CaseType | CaseType[],
  fallback: string,
): string => {
  const types = Array.isArray(caseTypes) ? caseTypes : [caseTypes];
  for (const caseType of types) {
    const label = priceFor(list, caseType)?.label?.trim();
    if (label) return label;
  }
  return fallback;
};

export const bestCents = (p?: Pricings): number => {
  if (!p) return 0;

  const discounted = p.amount_after_plan;
  const base = p.amount ?? 0;

  return typeof discounted === 'number' && discounted >= 0 ? discounted : base;
};

export const toDollars2 = (cents: number): string => (cents / 100).toFixed(2);
